import React, { useEffect, useState } from 'react';
import API_URL from '../../apiConfig';
import Navbar from '../../composants/site/Navbar';
import Footer from '../../composants/site/Footer';

const NosMeditations = () => {
    const [meditations, setMeditations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMedit, setSelectedMedit] = useState(null);

    const getImgUrl = (linkImg) => {
        if (!linkImg) return 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=600';
        try {
            let first = linkImg;
            if (Array.isArray(linkImg)) first = linkImg[0];
            else if (typeof linkImg === 'string' && linkImg.startsWith('[')) first = JSON.parse(linkImg)[0];
            else if (typeof linkImg === 'string' && linkImg.includes(',')) first = linkImg.split(',')[0];
            
            if (!first) return 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=600';
            return first.startsWith('http') ? first : `${API_URL}${first.startsWith('/') ? '' : '/'}${first}`;
        } catch(e) {
            return (typeof linkImg === 'string' && linkImg.startsWith('http')) ? linkImg : `${API_URL}${linkImg && linkImg.startsWith('/') ? '' : '/'}${linkImg}`;
        }
    };

    const fetchMeditations = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${API_URL}/api/meditations/allmeditations`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            });
            const data = await res.json();
            if (data.success) {
                const published = data.meditations.filter(m => Number(m.published || m.publie) === 1);
                setMeditations(published);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = "LAMP | Nos Méditations";
        fetchMeditations();
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="nos-meditations-page bg-light">
            <Navbar />
            <div className="container py-5 mt-5">
                <div className="text-center mb-5 mt-4">
                    <span className="text-primary fw-bold text-uppercase d-block mb-2 animate__animated animate__fadeInDown" style={{ letterSpacing: '2px' }}>Parole & Vie</span>
                    <h1 className="display-4 fw-bold outfit text-dark mb-0 animate__animated animate__fadeInUp">Nos Méditations</h1>
                    <div className="mx-auto mt-3 bg-primary rounded-pill mb-4" style={{ width: '80px', height: '4px' }}></div>
                </div>

                <div className="meditations-container">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }}></div>
                        </div>
                    ) : (
                        <div className="row g-4">
                            {meditations.length > 0 ? (
                                meditations.map(m => (
                                    <div key={m.idMedit} className="col-md-6 col-lg-4">
                                        <div 
                                            className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 meditations-card-hover cursor-pointer border-light border"
                                            onClick={() => setSelectedMedit(m)}
                                        >
                                            <div style={{ height: '300px', overflow: 'hidden' }} className="position-relative">
                                                <img 
                                                     src={getImgUrl(m.linkImg)} 
                                                     alt="thumb" 
                                                     className="w-100 h-100 object-cover transition-img" 
                                                />
                                                <div className="position-absolute bottom-0 start-0 m-3 z-3">
                                                    <span className="badge bg-primary rounded-pill px-3 py-2 shadow-sm border border-white" style={{ fontSize: '0.65rem' }}>{m.type}</span>
                                                </div>
                                                <div className="img-overlay"></div>
                                            </div>
                                            <div className="card-body p-4 d-flex flex-column">
                                                <div className="d-flex justify-content-between mb-3 text-muted extra-small fw-medium">
                                                    <span><i className="bi bi-clock me-1"></i> {new Date(m.datePublication).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}</span>
                                                    <span><i className="bi bi-share me-1"></i> {m.nbreShare || 0}</span>
                                                </div>
                                                <h5 className="card-title fw-bold text-dark mb-4 text-truncate-2" style={{ lineHeight: '1.4', fontSize: '1.25rem' }}>{m.textMedit}</h5>
                                                <div className="mt-auto d-flex justify-content-end">
                                                    <div className="text-primary fw-bold small text-uppercase">Lire <i className="bi bi-arrow-right-short fs-5 ms-1"></i></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-muted col-12 py-5 italic">Aucune méditation n'est encore disponible.</p>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de Lecture Méditation */}
            {selectedMedit && (
                <div className="medit-modal-overlay">
                    <style>{`
                        .site-header { display: none !important; }
                        .medit-modal-overlay {
                            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                            background: rgba(0,0,0,0.96); z-index: 10000;
                            display: flex; align-items: center; justify-content: center;
                            padding: 15px;
                        }
                        .medit-modal-content {
                            background: white; width: 100%; max-width: 1100px; max-height: 95vh;
                            border-radius: 30px; overflow-y: auto; position: relative;
                            box-shadow: 0 40px 80px rgba(0,0,0,0.6);
                            animation: modalFadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                        }
                        @keyframes modalFadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
                    `}</style>
                    <div className="medit-modal-content">
                        <button 
                             className="bg-dark text-white rounded-circle border-0 shadow" 
                             onClick={() => setSelectedMedit(null)}
                             style={{ position: 'absolute', top: '25px', right: '25px', width: '45px', height: '45px', zIndex: 100 }}
                        >
                            <i className="bi bi-x-lg fs-4"></i>
                        </button>

                        <div className="row g-0">
                            <div className="col-lg-5">
                                <div style={{ height: '100%', minHeight: '500px' }}>
                                    <img 
                                        src={getImgUrl(selectedMedit.linkImg)} 
                                        alt="full" 
                                        className="w-100 h-100 object-cover" 
                                    />
                                </div>
                            </div>
                            <div className="col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-center">
                                <div className="mb-4">
                                    <span className="badge bg-primary bg-opacity-10 text-primary px-4 py-2 rounded-pill text-uppercase mb-3" style={{ fontSize: '0.8rem', letterSpacing: '2px' }}>
                                        {selectedMedit.type}
                                    </span>
                                    <div className="text-muted small mb-2 fw-medium"><i className="bi bi-calendar3 me-2"></i> {new Date(selectedMedit.datePublication).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                                    <h2 className="display-5 fw-bold outfit text-dark mb-0">La Méditation</h2>
                                </div>
                                <div className="medit-text text-muted mb-5 flex-grow-1" style={{ whiteSpace: 'pre-wrap', fontSize: '1.25rem', lineHeight: '1.8' }}>
                                    {selectedMedit.textMedit}
                                </div>
                                <div className="p-4 bg-primary bg-opacity-5 rounded-4 border-start border-4 border-primary mb-5 shadow-sm">
                                    <p className="italic text-primary mb-1 fw-bold fs-5">
                                        "Ta parole est une lampe à mes pieds, et une lumière sur mon sentier."
                                    </p>
                                    <span className="fw-bold text-dark">— Psaumes 119:105</span>
                                </div>
                                <div className="d-grid mt-2">
                                    <button className="btn btn-primary btn-lg rounded-pill shadow-lg fw-bold py-3 text-uppercase" style={{ letterSpacing: '1px' }}>
                                        <i className="bi bi-share-fill me-2"></i> PARTAGER CETTE PAROLE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
            <style>{`
                .extra-small { font-size: 0.75rem; }
                .meditations-card-hover { transition: all 0.4s ease; }
                .meditations-card-hover:hover { transform: translateY(-10px); box-shadow: 0 25px 50px rgba(0,0,0,0.12) !important; }
                .meditations-card-hover:hover .transition-img { transform: scale(1.08); }
                .transition-img { transition: transform 0.8s ease; }
                .img-overlay { position: absolute; top:0; left:0; width:100%; height:100%; background: linear-gradient(to top, rgba(0,0,0,0.4), transparent); }
            `}</style>
        </div>
    );
};

export default NosMeditations;
